import dataPlatform from "@/assets/images/advantage/icon-1.svg"
import businessAnalysis from "@/assets/images/advantage/icon-2.svg"
import businessInnovation from "@/assets/images/advantage/icon-3.svg"
import ecosystem from "@/assets/images/advantage/icon-4.svg"
import AWS from "@/assets/images/advantage/aws.png"
import AliYun from "@/assets/images/advantage/aliyun.png"

export const HOME_MORE_RESOURCE = [
  {
    name: "TiDB 社区",
    description: "与社区成员学习，讨论",
    icon: "/index/5.社区.svg",
    link: "https://tidb.net/",
  },
  {
    name: "PingCAP Education",
    description: "了解培训服务、学习认证相关信息",
    icon: "/index/9.学习.svg",
    link: "/education",
  },
  {
    name: "博客",
    description: "分享技术内容与思考",
    icon: "/index/7.博客.svg",
    link: "/blog",
  },
  {
    name: "TiDB 文档",
    description: "学习如何使用 TiDB",
    icon: "/index/3.文档.svg",
    link: "https://docs.pingcap.com/zh/tidb/stable",
  },
]

export const ADVANTAGE_NODES = [
  {
    id: 1,
    title: "融合的数据平台",
    desc:
      "打破数据壁垒，合而为一。事务性与分析型处理完全基于一体化的数据基座。",
    image: dataPlatform,
    alt: "融合的数据平台",
  },
  {
    id: 2,
    title: "实时的商业分析",
    desc:
      "在线数据分析与决策，分秒必争。强一致性保障基于数据的决策，分毫不差。",
    image: businessAnalysis,
    alt: "实时的商业分析",
  },
  {
    id: 3,
    title: "敏捷的业务创新",
    desc: "数据库，亦服务；云原生，高弹性；金融级高可用。",
    image: businessInnovation,
    alt: "敏捷的业务创新",
  },
  {
    id: 4,
    title: "开放的生态系统",
    desc:
      "基于 CNCF 项目的中国领先开源社区。无缝支持多云架构对接丰富的数据工具生态。",
    image: ecosystem,
    alt: "开放的生态系统",
  },
]

export const ADVANTAGE_SECTION = {
  h4: "我们的产品优势",
  h1: "一栈式数据服务平台",
}

export const CASE_LIST = [
  {
    id: 1,
    image: AWS,
    desc:
      "通过亚马逊云科技 Marketplace（中国区）网站 ，快速部署和使用 TiDB，获得更顺滑的分布式数据库云端体验",
    link: "https://awsmarketplace.amazonaws.cn/marketplace/pp/prodview-idxqhvltxosqc?utm_source=pingcap&utm_medium=referral&utm_campaign=homepage",
  },
  {
    id: 2,
    image: AliYun,
    desc:
      "通过阿里云心选商城部署和使用 TiDB，开启新一代 HTAP 数据库的云端体验之旅",
    link: "https://market.aliyun.com/products/56024006/cmgj00054143.html?utm_source=pingcap&utm_medium=referral&utm_campaign=homepage",
  },
]

export const HOME_INSIGHT = {
  insight: "行业洞见",
  title: "PingCAP 行业洞见",
  subtitle:
    "基于技术与开放模式创新、在全球化跨生态系统协作及数字化转型战略中探索与研究助力企业蓬勃发展之道。",
  moreInsight: "查看所有行业洞见",
  moreSolution: "查看更多解决方案",
}

export const HOME_JOINT_SOLUTION = {
  sectionName: "联合解决方案",
  title: "用科技重塑商业模式，以合作谱写繁荣生态",
}

export const COOPERATIVE_PARTNER = {
  h1: "合作伙伴",
  h4: "我们的合作伙伴",
  h5:
    "秉承开放、合作、共赢的合作理念，通过提供销售、市场、技术等全方位的支持，助力合作伙伴成功构建基于 PingCAP 的业务，实现业务创新，持续为客户和伙伴创造价值。",
}
